export function getColorRgb(code: string, alpha?: number): string {
  let rgb = '';

  if (code) {
    if (!alpha) {
      rgb = `rgb(${code})`;
    } else {
      rgb = `rgba(${code}, ${alpha})`;
    }
  }

  return rgb;
}

export function getColorContrastRgb(code: string, alpha?: number): string {
  if (code) {
    let vals: string[] = code.split(',');
    if (vals && vals.length == 3) {
      let red: number = +vals[0];
      let green: number = +vals[1];
      let blue: number = +vals[2];
      var sum = Math.round((red * 299 + green * 587 + blue * 114) / 1000);
      return sum > 128 ? getColorRgb('0,0,0', alpha) : getColorRgb('255,255,255', alpha);
    }
  }
  return getColorRgb('255,255,255', alpha);
}
